import { _StoreWithGetters, PiniaCustomProperties, _StoreWithState } from 'pinia';
import { UnwrapRef } from 'vue';

import { PatientStateInterface } from './state';
import { PatientGetters } from './getters';

import { Extension, Patient, Reference } from 'fhir/r4';
import mixpanel from 'mixpanel-browser'

import {
  authRegister,
  patientUpdate,
  refreshCustomData,
  favoriteAdd,
  favoriteRemove,
  configUpdate
} from 'src/services/functions';

type PatientActions = {
  read(): Promise<PatientStateInterface>;
  update(payload: Patient): Promise<void>;
  create(payload: Patient, code: string): Promise<void>;
  favoriteAdd(payload: Reference): Promise<void>;
  favoriteRemove(payload: Reference): Promise<void>;
  setConfig(payload: Extension[]): Promise<void>;
};

const actions: PatientActions &
  ThisType<
    PatientActions &
      UnwrapRef<PatientStateInterface> &
      _StoreWithState<
        string,
        PatientStateInterface,
        PatientGetters,
        PatientActions
      > &
      _StoreWithGetters<PatientGetters> &
      PiniaCustomProperties
  > = {
  async read() {
    const user = await refreshCustomData();
    user.id = String(user._id);
    user.generalPractitioner = user.generalPractitioner?.map(el => {
      return {
        ...el,
        reference: (el.reference as unknown as { $oid: string }).$oid
      };
    }) || [];
    this.$state = user;
    mixpanel.people.set({
      $first_name: this.givenName,
      $last_name: this.lastName,
      $email: this.email,
      $phone: this.phone
    })
    mixpanel.register({
      gender: this.gender,
      age: this.age,
    })

    return user;
  },
  async update(payload) {
    await patientUpdate(payload);
    await this.read();
  },
  create(payload, code) {
    return authRegister(payload, code);
  },
  favoriteAdd(payload) {
    return favoriteAdd(payload).then(() => {
      if (!this.generalPractitioner) this.generalPractitioner = [];
      this.generalPractitioner.push(payload);
      mixpanel.track('Favorite Add', {
        reference: payload.reference,
        specialty: payload.extension?.find((el) => el.url === 'degree')?.valueString || ''
      })
    });
  },
  favoriteRemove(payload) {
    return favoriteRemove(payload).then(() => {
      if (!this.generalPractitioner) this.generalPractitioner = [];
      this.generalPractitioner = this.generalPractitioner.filter(
        gp => gp.reference !== payload.reference
      );
      mixpanel.track('Favorite Remove', {
        reference: payload.reference,
        specialty: payload.extension?.find((el) => el.url === 'degree')?.valueString || ''
      })
    });
  },
  setConfig (payload) {
    return configUpdate(payload).then(() => {
      if (!this.extension) this.extension = [];
      const config = this.extension.find((el) => el.url === 'config-accelerate')
      if (config) {
        config.extension = payload
      } else {
        this.extension.push({
          url: 'config-accelerate',
          extension: payload
        })
      }
    })
  }
};

export default actions;
